export default "__VITE_PUBLIC_ASSET__0ec187ca__"